export default function PromotionsSection() {
  const promos = [
    {
      icon: 'ri-gift-2-line',
      title: '新人专属礼包',
      desc: '首次注册即送188元游戏礼金，充值再享100%返利',
      color: 'primary',
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'VIP尊享特权',
      desc: '成为VIP会员，享受专属客服、高额返水、生日礼遇',
      color: 'accent',
    },
    {
      icon: 'ri-fire-line',
      title: '每日签到有礼',
      desc: '每日登录签到领奖励，连续签到30天赢超级大奖',
      color: 'primary',
    },
    {
      icon: 'ri-trophy-line',
      title: '竞技赛事',
      desc: '参与各类游戏竞技赛，赢取现金大奖和专属荣誉称号',
      color: 'accent',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            <a href="#promotions">优惠活动</a>
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            多重福利活动，让您的游戏之旅更加精彩
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {promos.map((promo) => {
            const isPrimary = promo.color === 'primary';
            return (
              <div
                key={promo.title}
                className="group relative p-6 rounded-2xl border border-background-200/70 bg-background-50 hover:border-primary-300 transition-all duration-300 cursor-pointer hover:-translate-y-1"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                  isPrimary ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
                }`}>
                  <i className={`${promo.icon} text-xl`}></i>
                </div>
                <h3 className="text-lg font-medium text-foreground-900 mb-2">{promo.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{promo.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}